<p-dialog
   *ngIf="service.inactiveDoctors()"
   header="Inactive doctors"
   [(visible)]="service.inactiveDoctorListDialogVisible"
   [modal]="true"
   class="vsp-inactive-dialog"
   [style]="{ width: '80vw' }"
   [draggable]="false"
   [resizable]="false">
   <hr />
   <h4 class="vsp-inactive-header">Lend-a-hand History</h4>
   <p-table
      showGridlines
      size="small"
      class="vsp-inactive-table-list"
      [value]="service.inactiveDoctors().lendahand"
      [scrollable]="true"
      scrollHeight="calc(50vh - 100px)"
      [style]="{ width: '75vw' }"
      [responsiveLayout]="'scroll'">
      <ng-template #header>
         <tr>
            <th></th>
            <th>Doctor Name</th>
            <th>Home Hospital</th>
            <th>Date Last Worked</th>
            <th>Total Hours</th>
         </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
         <tr>
            <td
               colspan="5"
               class="vsp-empty-message">
               There are no inactive doctors.
            </td>
         </tr>
      </ng-template>
      <ng-template
         #body
         let-doctor>
         <tr>
            <td>
               <button
                  (click)="addDoctor(doctor)"
                  class="v-button v-button-sm v-darkgreen-border">
                  Add
               </button>
            </td>
            <td>{{ doctor.firstName }} {{ doctor.lastName }}</td>
            <td>{{ doctor.practiceName }}</td>
            <td>{{ doctor.lastDate | date : "mediumDate" }}</td>
            <td>{{ doctor.totalHours }}</td>
         </tr>
      </ng-template>
   </p-table>
   <h4 class="vsp-inactive-header">Relief History</h4>
   <p-table
      showGridlines
      size="small"
	  class="vsp-inactive-table-list"
      [value]="service.inactiveDoctors().relief"
      [scrollable]="true"
      scrollHeight="calc(50vh - 100px)"
      [style]="{ width: '75vw' }"
      [responsiveLayout]="'scroll'">
      <ng-template #header>
         <tr>
            <th></th>
            <th>Doctor Name</th>
            <th>Agency Name</th>
            <th>Date Last Worked</th>
         </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
         <tr>
            <td
               colspan="5"
               class="vsp-empty-message">
               There are no inactive doctors.
            </td>
         </tr>
      </ng-template>
      <ng-template
         #body
         let-doctor>
         <tr>
            <td>
               <button
                  (click)="addDoctor(doctor)"
                  class="v-button v-button-sm v-darkgreen-border">
                  Add
               </button>
            </td>
            <td>{{ doctor.firstName }} {{ doctor.lastName }}</td>
            <td>{{ doctor.agencyName }}</td>
            <td>{{ doctor.lastDate | date : "mediumDate" }}</td>
         </tr>
      </ng-template>
   </p-table>
   <h4 class="vsp-inactive-header">Removed employees</h4>
   <p-table
      showGridlines
      size="small"
      class="vsp-inactive-table-list"
      [value]="service.inactiveDoctors().employee"
      [scrollable]="true"
      scrollHeight="calc(50vh - 100px)"
      [style]="{ width: '75vw' }"
      [responsiveLayout]="'scroll'">
      <ng-template #header>
         <tr>
            <th></th>
            <th>Doctor Name</th>
            <th>Home Hospital</th>
            <th>Date Last Worked</th>
            <th>Total Hours</th>
         </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
         <tr>
            <td
               colspan="5"
               class="vsp-empty-message">
               There are no removed doctors.
            </td>
         </tr>
      </ng-template>
      <ng-template
         #body
         let-doctor>
         <tr>
            <td>
               <button
                  (click)="addDoctor(doctor)"
                  class="v-button v-button-sm v-darkgreen-border">
                  Add
               </button>
            </td>
            <td>{{ doctor.firstName }} {{ doctor.lastName }}</td>
            <td>{{ doctor.practiceName }}</td>
            <td>{{ doctor.lastDate | date : "mediumDate" }}</td>
            <td>{{ doctor.totalHours }}</td>
         </tr>
      </ng-template>
   </p-table>
   <ng-template pTemplate="footer">
      <!--
      <button
         (click)="close()"
         class="v-button v-button-md v-darkgreen-border m-1">
         Close
      </button>-->
   </ng-template>
</p-dialog>
